import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import para redirecionamento
import './signin.css';

import logo from '../../components/Header/Logo_oficial_CCB.png';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { signIn, loadingAuth, user } = useContext(AuthContext);
  const navigate = useNavigate(); // Hook para redirecionamento

  
  useEffect(() => {
    const storageUser = localStorage.getItem('@userLogado');

    if (storageUser) {
      const parsedUser = JSON.parse(storageUser);
      const now = Date.now();
      const expirationTime = 7 * 24 * 60 * 60 * 1000; // 7 dias em ms

      if (parsedUser.lastLogin && now - parsedUser.lastLogin < expirationTime) {
        navigate('/home'); 
      }
    }
  }, [navigate]); // Executa apenas uma vez ao carregar a tela

  async function handleSignIn(e) {
    e.preventDefault();

    if (email && password) {
      await signIn(email, password);
    } else {
      toast.error("Preencha todos os campos!");
    }
  }

  return (
    <div className="container-center">
      <div className="login">
        <div className="login-area">
          <img src={logo} alt="Logo do sistema de chamados" />
        </div>

        <form onSubmit={handleSignIn}>
          <h1>CCB Digital</h1>
          <input
            type="text"
            placeholder="username"
            value={email}
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
          />

          <input
            type="password"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">
            {loadingAuth ? "Carregando..." : "Acessar"}
          </button>
        </form>

        <Link></Link>
      </div>
    </div>
  );
}
